"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.loanAdministrationSchema = void 0;
var pre_claim_1 = require("../../pre-claim");
exports.loanAdministrationSchema = {
    type: ['object', 'null'],
    additionalProperties: {
        not: true,
        errorMessage: '- should not have additional property ${0#}',
    },
    properties: {
        underwritingReviewRequiredDiscloserIndicator: {
            type: ['integer', 'null'],
            enum: __spreadArrays(Object.values(pre_claim_1.UnderwritingReviewDiscloser), [null]),
            errorMessage: 'should equate to a valid underwritingReviewRequiredDiscloserIndicator enum value or null',
        },
        issueToManagementRecordStatusCode: {
            type: ['integer', 'null'],
            enum: __spreadArrays(Object.values(pre_claim_1.IssueToManagementStatus), [null]),
            errorMessage: 'should equate to a valid issueToManagementRecordStatusCode enum value or null',
        },
        preApprovedPropertyRepairAmount: {
            type: ['number', 'null'],
            maximum: 9999999999999,
            minimum: -9999999999999,
            decimal: [15, 2],
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision',
        },
    },
};
